module.exports = __webpack_public_path__ + "static/media/pdf.88165cc5.svg";